export class ExternalPaymentStatusDto {
	paymentId!: number;
	status!: string;
	canFinalizeReservation!: boolean;
}
